/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  createSafeguardingRecordFormDataInterface,
  updateSafeguardingRecordFormDataInterface,
} from '../../pages/myscr-records/SafeGuardingRecords'
import {
  createRecordFormDataInterface,
  updateRecordFormDataInterface,
} from '../../pages/myscr-records/TrainingRecord'
import {
  employmentDetails,
  profileData,
  safeguardingRecordsDetails,
} from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { get, patch, post } from '../https'

export const getProfile = (): Promise<unknown> => {
  return get(`${BASE_URL}/profile`)
}

export const updateProfile = (data: profileData): Promise<unknown> => {
  delete data.basicInformation.profileImageUrl
  return patch(`${BASE_URL}/profile`, data, null)
}

export const getProfileEmployment = (): Promise<unknown> => {
  return get(`${BASE_URL}/employment-details`)
}

export const updateProfileEmployment = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
): Promise<unknown> => {
  console.log(data)
  return patch(
    `${BASE_URL}/employment-details`,
    {
      employmentDetails: data,
    },
    null
  )
}

export const getSafeguardingRecords = (): Promise<unknown> => {
  return get(`${BASE_URL}/safeguarding-records`)
}

export const updateSafeguardingRecords = (
  data: safeguardingRecordsDetails
): Promise<unknown> => {
  return patch(`${BASE_URL}/safeguarding-records`, data, null)
}

export const getTrainingRecordCategories = (): Promise<unknown> => {
  return get(`${BASE_URL}/training-record-categories`)
}
export const getSafeguardingRecordCategories = (): Promise<unknown> => {
  return get(`${BASE_URL}/safeguarding-record-categories`)
}

export const getProfileTrainingRecord = (): Promise<unknown> => {
  return get(`${BASE_URL}/training-records`)
}

export const getProfileSafeguardingRecord = (): Promise<unknown> => {
  return get(`${BASE_URL}/safeguarding-records`)
}

export const createProfileTrainingRecord = (
  data: createRecordFormDataInterface[]
): Promise<unknown> => {
  const formData = {
    trainingRecords: data,
  }
  return post(`${BASE_URL}/training-records`, formData, null)
}

export const createProfileSafeguardingRecord = (
  data: createSafeguardingRecordFormDataInterface[]
): Promise<unknown> => {
  const formData = {
    safeguardingRecords: data,
  }
  return post(`${BASE_URL}/safeguarding-records`, formData, null)
}

export const updateProfileTrainingRecord = (
  data: updateRecordFormDataInterface[]
): Promise<unknown> => {
  const formData = {
    trainingRecords: data?.map((item) => {
      const { createdAt, updatedAt, title, ...rest } = item
      return {
        ...rest,
        date: item.date && new Date(item.date).toISOString(),
        verificationDate:
          item.verificationDate &&
          new Date(item.verificationDate).toISOString(),
        reviewDate: item.reviewDate && new Date(item.reviewDate).toISOString(),
      }
    }),
  }
  return patch(`${BASE_URL}/training-records`, formData, null)
}

export const updateProfileSafeguardingRecord = (
  data: updateSafeguardingRecordFormDataInterface[]
): Promise<unknown> => {
  const formData = {
    safeguardingRecords: data?.map((item) => {
      const { title, ...rest } = item
      return {
        ...rest,
        issueDate: item.issueDate && new Date(item.issueDate).toISOString(),
        verificationDate:
          item.verificationDate &&
          new Date(item.verificationDate).toISOString(),
        expiryDate: item.expiryDate && new Date(item.expiryDate).toISOString(),
      }
    }),
  }
  return patch(`${BASE_URL}/safeguarding-records`, formData, null)
}
